import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationWindowTypes } from '@components/confirmation-window/confirmation-window.component';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrl: './confirmation-dialog.component.css',
    standalone: false,
})
export class ConfirmationDialogComponent {
    readonly complexType = ConfirmationDialogType.COMPLEX;
    readonly simpleType = ConfirmationDialogType.SIMPLE;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            type: ConfirmationDialogType;
            title: string;
            title2: string;
            message: string;
            message2: string;
            discardButton: string;
            saveButton: string;
            backButton: string;
            redDiscard: boolean;
            saveDisabled: boolean;
            width: string;
        },
        private dialogRef: MatDialogRef<ConfirmationDialogComponent>
    ) {}

    discardChanges() {
        this.emitValue(ConfirmationDialogOption.DISCARD);
    }

    goBack() {
        this.emitValue(ConfirmationDialogOption.GO_BACK);
    }

    saveChanges() {
        if (this.data.saveDisabled) return;
        this.emitValue(ConfirmationDialogOption.SAVE);
    }

    private emitValue(value: ConfirmationDialogOption) {
        this.dialogRef.close(value);
    }
}

export enum ConfirmationDialogType {
    UNDEFINED = 'undefined',
    COMPLEX = 'complex',
    SIMPLE = 'simple',
}

export enum ConfirmationDialogOption {
    UNDEFINED = 'undefined',
    DISCARD = 'discard',
    GO_BACK = 'goBack',
    SAVE = 'save',
}
